/* Uncomment if kubient fixes player fixes IE11 support */
//import 'promise-polyfill/src/polyfill';

import './style.css';
import { PlayKubientAd } from './playKubientAd';
import { isIE11 } from './browserCheck';

/***
 * Due to incompatibility with IE11 we prevent the window.beforeStreamStart from being created
 */
if (!isIE11()) {
    /***
     * Creates and makes globally accessible a function with a callback that is called when a kubient ad plays or does not play.
     * @param next
     */
    window.beforeStreamStart = next => {
        PlayKubientAd({
            kubientId: '48werXnPU67ggaXzh3-_qOqrK-PMHETPEdRzGgdFW8oKDw425GO_',
            kubientTimeout: 5000
        })
            .then(result => {
                console.log('Kubient', result.message);
                next(result.message);
            })
            .catch(err => {
                console.log('Kubient', err.message);
                next(err.message);
            });
    };
} else {
    console.log('Kubient not loaded browser IE11');
}
